package com.iregained.site.components.sections.header

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.before
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.*

// 1. The Underline Animation for Navigation Links
val AnimatedHeaderLinkStyle = CssStyle {

    val palette = colorMode.toSitePalette()

    base {
        Modifier.position(Position.Relative) // NEW: Required so the absolute underline anchors to the button
            .color(palette.custom.darkText).padding(leftRight = 16.px, topBottom = 8.px).borderRadius(8.px).transition(
                Transition.of("color", 0.2.s),
                Transition.of("background-color", 0.2.s),
                Transition.of("transform", 0.1.s)
            )
    }

    // NEW: The classic underline element (starts invisible at 0 width)
    before {
        Modifier.styleModifier { property("content", "\"\"") } // CSS requirement for pseudo-elements
            .position(Position.Absolute).bottom(0.px)
            .left(10.percent) // Slightly inset to account for the pill's rounded corners
            .width(0.percent).height(3.px).borderRadius(2.px).backgroundColor(palette.brand.primaryBlue)
            .transition(Transition.of("width", 0.3.s))
    }

    hover {
        // Soft background highlight on hover
        Modifier.backgroundColor(palette.brand.primarySoft).color(palette.brand.primaryBlue)
    }

    // NEW: Triggers the underline width to expand smoothly when the parent is hovered
    cssRule(":hover::before") {
        Modifier.width(80.percent) // 80% width + 10% left offset = perfectly centered line
    }

    active {
        // Modern tactile click effect (scales down slightly when pressed)
        Modifier.scale(0.95)
    }
}

// 2. The CTA Button Hover Effect
val HeaderButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier.backgroundColor(palette.brand.primaryBlue)
            .transition(Transition.of("transform", 0.2.s), Transition.of("background-color", 0.2.s))
    }
    hover {
        Modifier.backgroundColor(palette.brand.primaryBlueHover).translateY((-1).px) // Lifts the button up slightly
    }
}

// 3. The Hamburger Menu Hover Animation
val HamburgerIconStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.2.s))
    }
    hover {
        Modifier.rotate(90.deg)
    }
}

// 4. The Logo Hover Effect
val LogoStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.2.s), Transition.of("filter", 0.2.s))
    }
    hover {
        Modifier.scale(1.05).styleModifier { property("filter", "drop-shadow(0px 2px 5px rgba(0,0,0,0.1))") }
    }
}

val DropdownItemStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier.fillMaxWidth().padding(leftRight = 20.px, topBottom = 12.px).color(palette.custom.darkText)
            .fontSize(15.px).transition(
                Transition.of("background-color", 0.2.s), Transition.of("color", 0.2.s)
            ).textDecorationLine(TextDecorationLine.None)
    }
    hover {
        Modifier
            // We use the Soft Teal you added in the 60-30-10 rule update!
            .backgroundColor(palette.brand.primarySoft).color(palette.brand.primaryBlue)
    }
}

val HeaderLinkStyle = CssStyle {
    base {
        Modifier
            .padding(leftRight = 20.px, topBottom = 10.px)
            .borderRadius(30.px)
            .fontSize(16.px)
            .fontWeight(FontWeight.Medium)
            .textDecorationLine(TextDecorationLine.None)
            .whiteSpace(WhiteSpace.NoWrap)
            .backgroundColor(Colors.Transparent)
            .transition(Transition.of("all", duration = 0.2.s, timingFunction = AnimationTimingFunction.EaseInOut))
    }
    // Pure CSS Hover - 100% reliable
    hover {
        Modifier
            .backgroundColor(colorMode.toSitePalette().brand.primarySoft)
            .color(colorMode.toSitePalette().brand.primaryBlue)
    }
}

val UtilityLinkStyle = CssStyle {
    base {
        Modifier
            .textDecorationLine(TextDecorationLine.None)
            .padding(leftRight = 12.px, topBottom = 8.px)
            .borderRadius(8.px)
            .transition(Transition.of("background-color", duration = 0.2.s))
    }
    hover {
        Modifier.backgroundColor(colorMode.toSitePalette().custom.lightGray)
    }
}